"use client";

import { ReactNode } from "react";
import { useSelector } from "react-redux";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { ClarityWrapper } from "@stadium/services/ms-clarity";
import HubspotTracking from "@stadium/services/hubspot/tracking";

import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";

import { getAnalyticsId } from "@helpers/analytics";
import { getStoreAnalytics } from "@selectors/store";
import { useAnalyticsContext } from "@components/provider/analytics";
import { decodeMeta } from "@helpers/route";

import { HUBSPOT_DEFAULT_CONFIG } from "@stadium/services/hubspot/constants";

const AppAnalyticsWrapper = ({ children, meta = "" }: { children: ReactNode; meta?: string }) => {
  const { currentUserData, loading } = useCurrentUserContext();
  const { spreeId, email } = currentUserData;
  const { asPath } = useRouter();
  const analytics = useSelector(getStoreAnalytics);
  const { isLoading } = useAnalyticsContext();
  const { hostname } = decodeMeta(meta);

  return (
    <>
      <ClarityWrapper
        userId={spreeId}
        apiKey={
          getAnalyticsId({
            asPath,
            hostname,
            isStoreLoading: isLoading,
            service: "clarity",
            analytics,
          })[0]
        }
        isUserLoading={loading}
      />
      <HubspotTracking
        id={HUBSPOT_DEFAULT_CONFIG.portalId}
        path={asPath}
        isUserLoading={loading}
        email={email}
      >
        {children}
      </HubspotTracking>
    </>
  );
};

export default AppAnalyticsWrapper;
